// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataNumberInput } from '@furo/data-input/src/furo-data-number-input.js';

export class FormFuroFatFloat extends FuroDataNumberInput {}

window.customElements.define('form-furo-fat-float', FormFuroFatFloat);
